import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';

import logoImg from '../../images/logo.png';
import roarLogoHeader from '../../images/roar_logo_header.svg';
import Logo from '../icons/logo';
import TextLogo from '../icons/logo-text';

const useStyles = makeStyles(theme => ({
  logo: {
    display: 'inline-block',
    color: 'inherit'
  },
  logoIcon: {
    height: 46,
    fontSize: 100,
    [theme.breakpoints.up('sm')]: {
      fontSize: 115
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 130
    }
  },
  additionalLogo: {
    display: 'flex',
    alignItems: 'center'
  },
  additionalLogoImg: {
    display: 'block',
    width: 46,
    height: 46,
    marginRight: theme.spacing(2)
  },
  additionalLogoIcon: {
    fontSize: 76,
    height: 20
  }
}));

const HeaderLogo = ({ siteTitle, isColor }) => {
  const classes = useStyles();
  const theme = useTheme();

  // Internet Explorer 6-11
  let isIE;
  if (typeof document !== 'undefined') {
    isIE = /* @cc_on!@ */ false || !!document.documentMode;
  }
  // Edge 20+
  let isEdge;
  if (typeof window !== 'undefined') {
    isEdge = !isIE && !!window.StyleMedia;
  }

  return (
    <a href="/" className={classes.logo} title={siteTitle}>
      {isEdge || isIE ? (
        <div className={classes.additionalLogo}>
          <img
            className={classes.additionalLogoImg}
            src={logoImg}
            alt={siteTitle}
          />
          <TextLogo
            className={classes.additionalLogoIcon}
            fill={
              isColor ? theme.palette.common.white : theme.palette.text.primary
            }
          />
        </div>
      ) : (
        <img src={roarLogoHeader} className={classes.logoIcon} />
      )}
    </a>
  );
};

HeaderLogo.propTypes = {
  siteTitle: PropTypes.string.isRequired,
  isColor: PropTypes.bool
};

HeaderLogo.defaultProps = {
  isColor: false
};

export default HeaderLogo;
